import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import store, { history } from '../store';
import App from '../App';
import '../index.css';
import { installSessionExpiredInterceptor } from './reducers/Api';

installSessionExpiredInterceptor(store, history);

// Theming + CssBaseline are handled inside App.js by BDSProvider — wrapping
// the tree in MuiThemeProvider here would fight the BDS theme.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </React.StrictMode>
);
